import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Client from '../../tools/client';
import Spinner from '../../components/reusable/spinner/spinner.component';
import ReadyToFulfillDisplay from '../../components/fulfillment/ready-to-fulfill-display/ready-to-fulfill-display.component';

import {
  BackLink,
  ContentContainer,
  MainContainer,
  MainTitle,
  Subtitle
} from '../../styles/page.styles';

const client = new Client();

const ReadyToFulfillPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getReadyToFulfill();
  }, []);

  const getReadyToFulfill = async () => {
    setLoading(true);
    try {
      const res = await client.getReadyToFulfill();
      
      setSummary(res.pullSummary);
      setOrders(res.breakdownByOrder);
    } catch (err) {
      console.error('Failed to fetch ready to fulfill data', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainContainer>
      <BackLink onClick={() => navigate(`/fulfillments`)}>
          Back To Fulfillments
      </BackLink>
      <MainTitle>Ready to Fulfill</MainTitle>
      <ContentContainer>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Subtitle>Select items or orders below to create a fulfillment</Subtitle>
            <ReadyToFulfillDisplay
              pullSummary={summary}
              breakdownByOrder={orders}
              refresh={getReadyToFulfill}
            />
          </>
        )}
      </ContentContainer>
    </MainContainer>
  );
};

export default ReadyToFulfillPage;